import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=3eca7079&scoped=true&lang=scss"

import exportComponent from "/Users/vadimkholodov/Documents/GitHub/vahta-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3eca7079"]])

export default __exports__